import { render, staticRenderFns } from "./ProjectDeleteModal.vue?vue&type=template&id=113746ba&scoped=true&"
import script from "./ProjectDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDeleteModal.vue?vue&type=style&index=0&id=113746ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113746ba",
  null
  
)

export default component.exports